import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { MenuItem } from 'primeng/api'

@Component({
  selector: 'basin-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  @Input() footerMenuItems: MenuItem[] = []
  @Input() menuThemeColor: string = ''
  @Input() currentPageTitle: string
  @Input() stantecLensClickable: boolean
  @Input() hideNavbar: boolean = false
  @Input() homeLink: boolean = true
  @Input() homeLinkClickable: boolean
  @Input() homeLinkText: string
  @Input() dropdownMenuSelector: boolean = false
  @Input() dropdownMenuItems: MenuItem[] = []
  @Input() logo: string = null
  @Input() logoClickable: boolean
  @Input() selectedDropdownMenuItem: MenuItem
  @Input() navItems = []
  @Input() displayHeaderIcon = false
  @Input() showProfile: boolean = true
  @Input() userProfile: any = {}
  @Input() profileMenuItems: MenuItem[] = []
  @Input() ellipsesMenu: boolean = true
  @Input() ellipsesMenuItems: MenuItem[] = []
  @Input() headerMenuIcon: string
  @Input() headerMenuItems: MenuItem[]
  @Output() stantecLensClick: EventEmitter<Event> = new EventEmitter<Event>()
  @Output() logoClick: EventEmitter<Event> = new EventEmitter<Event>()
  @Output() homeLinkClick: EventEmitter<Event> = new EventEmitter<Event>()
  menuDocked: boolean = false

  constructor(private cdRef: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.cdRef.detectChanges()
  }

  dockMenu(): void {
    this.menuDocked = true
  }

  unDockNavmenu(): void {
    this.menuDocked = false
  }

  stantecLensClicked(event: Event): void {
    this.stantecLensClick.emit(event)
  }

  logoClicked(event: Event): void {
    this.logoClick.emit(event)
  }

  homeLinkClicked(event: Event): void {
    this.homeLinkClick.emit(event)
  }
}
